<template>
	<div>
        <Loading :value="loading" ></Loading>
        <!-- MODAL AJOUTER UNE ZONES -->
    <v-dialog v-model="dialogAjoutFond" max-width="90%" persistent :overlay="true" scrollable>
      <v-card >
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
              <span  v-if="editForm == false"> Ajouter une demande de fonds </span>
            <span v-else >Modifier une demande de fonds  </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeDialog()" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
            <el-form id="formDmd"  :model="formDmd" :rules="rules" ref="formDmd" class="demo-form-inline">
                <v-layout row>
                    <v-flex xs6>
                        <div style="">
                            
                            <el-radio-group v-model="typeDmd"  size="mini">
                                <el-radio-button label="Projet"></el-radio-button>
                                <el-radio-button label="Carburant"></el-radio-button>
                                <el-radio-button label="Autre"></el-radio-button>
                            </el-radio-group>

                           <el-popover
                                placement="top-start"
                                title="Approvisionement carte de carburant"
                                width="500"
                                trigger="hover"
                                >
                                <el-table :data="helpDemande">
                                    <el-table-column width="20" property="num" label=""></el-table-column>
                                    <el-table-column width="600" property="text" label=""></el-table-column>
                                </el-table>
                                <el-button v-show="typeDmd == 'Carburant'" style="font-size:25px" icon="el-icon-question" slot="reference"  type="text" ></el-button>
                            </el-popover>

                        </div>
                    </v-flex>
                </v-layout>

                 <v-layout row>
                     <v-flex xs4 class="mr-2" v-show="typeDmd == 'Projet'" >
                            <el-form-item label="Projet *" prop="projet">
                                <el-select filterable  v-model="formDmd.projet" name="projet" placeholder="projet" style="width: 100%" @change="selectProjet" >
                                    <el-option v-for="item in listeProjet" :key="item.id" :label="item.libelle" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                    </v-flex>

                      <v-flex xs4 class="mr-2"  v-show="typeDmd != 'Projet'">
                            <el-form-item label="Projet" prop="projet">
                                <el-select filterable  v-model="formDmd.projet" name="projet" placeholder="projet" style="width: 100%" @change="selectProjet" >
                                    <el-option v-for="item in listeProjet" :key="item.id" :label="item.libelle" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                    </v-flex>

                     <v-flex xs4 class="mr-2" v-show="typeDmd == 'Projet'"   >
                            <el-form-item label="Chantier *" prop="chantier">
                                <el-select filterable v-model="formDmd.chantier" name="chantier" placeholder="chantier"  style="width: 100%">
                                    <el-option v-for="item in listeChantier" :key="item.id" :label="item.libelle" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                    </v-flex>

                      <v-flex xs4 class="mr-2" v-show="typeDmd != 'Projet'"  >
                            <el-form-item label="Chantier" prop="chantier">
                                <el-select filterable v-model="formDmd.chantier" name="chantier" placeholder="chantier"  style="width: 100%">
                                    <el-option v-for="item in listeChantier" :key="item.id" :label="item.libelle" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                    </v-flex>

                    <v-flex v-if="false" xs4 class="mr-2" v-show="typeDmd == 'Carburant'" >
                        <el-form-item label="Zone" prop="zone">
                            <el-autocomplete  v-model="formDmd.zone" name="zone" placeholder="nom de la zone"  style="width: 100%" :fetch-suggestions="loadZone" ></el-autocomplete>
                        </el-form-item>
                    </v-flex>

                    <v-flex xs4 class="mr-2" v-show="typeDmd == 'Autre'" >
                        <el-form-item label="Libelle *" prop="autre">
                            <el-autocomplete  v-model="formDmd.autre" name="autre" placeholder="selectionner"  style="width: 100%" :fetch-suggestions="loadAutre" ></el-autocomplete>
                        </el-form-item>
                    </v-flex>
                </v-layout>

                <v-layout row>
                     <v-flex xs3 >
                       <el-form-item label="Caisse concerne *" prop="caisse">
                            <el-select filterable style="width: 100%"   v-model="formDmd.caisseSelect" @change="handleChangeCaisse" placeholder="Selectionner une caisse">
                                <el-option
                                v-for="item in listeCaisse"
                                :key="item.id"
                                :label="item.libelle"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </v-flex>

                       <v-flex xs3  class="ml-1" v-show="typeDmd != 'Carburant'" >
                            <el-form-item label="Montant" prop="montant">
                                <el-input-number  :min="5"   v-model="formDmd.montant" name="montant" placeholder="saisir un montant"  style="width: 100%"></el-input-number>
                            </el-form-item>
                        </v-flex>

                        <v-flex xs3 class="ml-1">
                            <el-form-item label="Nom du demandeur" prop="demandeur">
                                <el-input type="text" name="demandeur" v-model="formDmd.demandeur" placeholder="nom du demandeur"  style="width: 100%"></el-input>
                            </el-form-item>
                        </v-flex>

                        <v-flex xs3 class="ml-1" >
                            <el-form-item label="Description" prop="motif">
                                <el-input type="textarea" :row="17"   v-model="formDmd.motif" name="motif" placeholder="motif de la demande"  style="width: 100%"></el-input>
                            </el-form-item>
                        </v-flex>
                </v-layout>

                <v-layout row v-show="typeDmd == 'Carburant'" >
                    <v-flex xs12>
                        <v-card>
                            <v-flex xs12 class="mb-2">
                                <v-alert :value="true" outline color="cyan" icon="info">
                                    Liste des cartes
                                </v-alert>
                                </v-flex>
                                <el-form id="formCarte"  :rules="rulesFormCarte" ref="formCarte"  label-position="top" :inline="true" :model="formCarte" class="demo-form-inline">
                                    <v-layout row>
                                            <v-flex md3 class="mr-1">
                                            <el-form-item  label="Carte à crediter" style="width:100%"   prop="identifiant" >
                                                    <el-select filterable  style="width:100%" v-model="formCarte.identifiant" placeholder="Selectionner une carte" >
                                                    <el-option
                                                        v-for="item in listeCarte"
                                                        :key="item.id"
                                                        :label="item.identifiant"
                                                        :value="item.identifiant">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            </v-flex>

                                            <v-flex md2>
                                                <el-form-item label="Quantité *"   prop="quantité" >
                                                    <el-input-number @change="calculTotal()" :min="1" value="qte"  placeholder="Quantité" v-model="formCarte.qte" style="width:100%" ></el-input-number >
                                                </el-form-item>
                                            </v-flex>

                                            <v-flex md2>
                                                <el-form-item label="Prix *"   prop="prix" >
                                                    <el-input-number @change="calculTotal()"  :min="1" value="prix HT"  placeholder="Prix" v-model="formCarte.prix" style="width:100%" ></el-input-number >
                                                </el-form-item>
                                            </v-flex>

                                            <v-flex md3 class="mr-1" >
                                                <el-form-item label="Montant à recharger" prop="montant">
                                                    <p><v-chip style="font-size:20px" label outline color="primary"><b>{{  new Intl.NumberFormat().format(formCarte.montant) }} </b></v-chip></p>
                                                </el-form-item>
                                            </v-flex>

                                            <v-flex md1>
                                                <el-form-item label=" " >
                                                    <el-button   type="primary" @click.stop="addListCarte('formCarte',formCarte)">Ajouter</el-button>
                                                </el-form-item>
                                            </v-flex>

                                        </v-layout>
                                    </el-form>
                                        <v-spacer></v-spacer>
                                        <v-chip style="font-size:20px" label outline color="green"><b>Total  (TTC): {{ new Intl.NumberFormat().format(totalCarte)}} fcfa</b></v-chip>
                                    <br>

                                    <v-layout row>
                                        <el-table :data="tableCarte" style="width: 100%" >
                                            <el-table-column prop="identifiant" label="identifiant" sortable> </el-table-column>
                                            <el-table-column prop="qte" label="qte" sortable> </el-table-column>
                                            <el-table-column prop="prix" label="prix" sortable> </el-table-column>
                                            <el-table-column prop="montant" label="Montant (Fcfa)">
                                                <template slot-scope="scope">
                                                    <el-tag
                                                    type="'info'"
                                                    disable-transitions>{{new Intl.NumberFormat().format(scope.row.montant) }}
                                                    </el-tag>
                                                </template>
                                            </el-table-column>

                                            <el-table-column label="Operations">
                                                <template slot-scope="scope">
                                                    <v-tooltip top>
                                                        <v-btn slot="activator" fab small icons color="red" @click.native.prevent="deleteRow(scope.$index, tableCarte)" dark>
                                                            <v-icon center>delete</v-icon>
                                                        </v-btn>
                                                        Supprimer la carte
                                                    </v-tooltip>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </v-layout>
                                    <br>
                        </v-card>

                    </v-flex>
                </v-layout>

                <v-flex xs4 class="ml-4" >
                        <p class="font-weight-thin" >Format (JPEG,PNG,PDF), 20 Mo maximum</p>
                        <a :href="logoDefaut" target="_blank">
                            <v-avatar :tile="true" size="240px" height="220px" color="grey lighten-4"> 
                                <img v-if="imagePdf" :src="logoPdf" alt="avatar">
                                <img v-if="!imagePdf" :src="logoDefaut" alt="avatar">
                            </v-avatar>
                            <br/>
                        </a>
                        <input name="docs" type="file" style="display:none" ref="fileLogo" accept="image/*,application/pdf" @change="onFileImageLogoPicked"/>
                        <v-btn color="primary" class="white--text" required @click.native="$refs.fileLogo.click()">Ajouter une pièce justificative <v-icon right dark>cloud_upload</v-icon></v-btn><br/>
                </v-flex>

                <v-layout row class="text-xs-right">
                    <v-flex xs12 >
                        <el-form-item class="text-xs-right" >
                            <v-btn color="grey" @click="resetForm('formDmd')" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                            <v-btn v-if="editForm == false" icons dark color="green" @click="submitForm('formDmd')">Enregistrer<v-icon right>save</v-icon></v-btn>
                            <v-btn v-else  icons dark color="green" @click="submitForm('formDmd')">Enregistrer les modifications<v-icon right>save</v-icon></v-btn>
                        </el-form-item>
                    </v-flex>
                </v-layout>
            </el-form>

        </v-card-text>
      </v-card>
    </v-dialog>
	</div>
</template>


<script>
    import Loading from '@/components/Loading'
    export default {
	components:{ Loading },
        name: "AjoutDemandeFond",
        props:["show","dmdDetail","editForm"],
        data()
        {
         return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            typeDmd: 'Projet',
            loading: false,
            labelPosition: 'left',
            dialogAjoutFond: false,
            disabledSelectCaisse:false,
            formDmd: {
                chantier: '',
                autre:'',
                montant:5,
                demandeur:'',
                motif:'',
                projet:'',
                caisseSelect:''
            },
            rules: {
                montant: [
                    { required: true, message: 'Veuillez saisir' },
                ],
                caisseSelect: [
                    {  message: 'Veuillez selectionner une caisse',trigger: 'change' },
                ],
            },
            listeProjet:[],
            listeChantier:[],
            listeCaisse: [],
            caisseSelect:"",
            logoDefaut: '/static/img-doc.png',
            logoPdf: '/static/pdf.png',
            imagePdf: false,
            //carte
             formCarte:{
                 identifiant:'',
                 montant:1,
                 qte:1,
                 prix:1
             },
             rulesFormCarte: {
                identifiant: [
                    {message: 'Veuillez selectionner une carte',trigger: 'blur',required: true  },
                ],
                
            },
            listeCarte:[],
            totalCarte:0,
            tableCarte:[],
            helpDemande:[{
                num: "1",
                text:"Selectionner les cartes ainsi que le montant"
            },
            {
                num: "2",
                text:"Après validation par le DG, Veuillez retirer le montant indiqué dans la caisse concernée puis effectuer l'approvisionnement de la carte dans le menu Logistique"
            },
            ]
         }
        },

        computed:{
        },
         watch: {
            show : function(newValue, oldvalue){
               this.dialogAjoutFond = newValue
               if(newValue == true)
               {
                  this.formDmd.demandeur = this.user.username ? this.user.username : ''           
                  this.logoDefaut = '/static/img-doc.png'
                   if(this.editForm == true){
                   this.formDmd.chantier = ''
                   this.formDmd.motif = ''
                   this.formDmd.montant =''
                   this.formDmd.caisseSelect  = ''
                   this.loadProjet();
                   this.loadCaisse();
                   this.formDmd.projet = this.dmdDetail.idProjet;
                   this.formDmd.autre = this.dmdDetail.autreDmd
                   
                   if(this.dmdDetail.autreDmd){
                     this.typeDmd = "Autre"
                   }
                   this.formDmd.chantier = this.dmdDetail.chantier;
                   this.formDmd.motif = this.dmdDetail.motif;
                   this.formDmd.montant = this.dmdDetail.montant
                   this.formDmd.caisseSelect  = this.dmdDetail.idCaisse;
                }
               }else {
                   //cahrgement de la liste des demandeur

                   this.formDmd = {};
               }
            },
        },

        methods: {
             calculTotal()
            {
                let total = this.formCarte.qte *  this.formCarte.prix;
                this.formCarte.montant =  total;
            },
            //enregistrement des images
            onFileImageLogoPicked(event)
                {
                    const files = event.target.files
                    let filename = files[0].name;
                    if (filename.lastIndexOf(".") <= 0)
                    {
                        return alert("Veuillez selectionner un  format de fichier valide ")
                    }
                    if(files[0].type == "application/pdf"){
                        this.logoDefaut = this.logoPdf;
                        const fileReader = new FileReader()
                        fileReader.addEventListener("load", () => {
            
                    })
                    fileReader.readAsDataURL('/static/pdf.png')
                    // this.logoDefaut = files[0]
                    }
                    const fileReader = new FileReader()
                    fileReader.addEventListener("load", () => {
                        this.logoDefaut = fileReader.result
                    })
                    this.imagePdf = false
                    fileReader.readAsDataURL(files[0])
                    this.logoDefaut = files[0]
                    if(files[0]['type'].split("/").pop() == 'pdf') {
                        this.imagePdf = true
                     }
                },

             addListCarte(formName,item){
                 if(this.formCarte.montant  < 5 ){
                      this.$message.error("Veuillez selectionner un montant supérieur ou égale à 5 fcfa");
                      return
                 }
                this.$refs[formName].validate((valid) => {
                    if (valid)
                    {
                        this.tableCarte.push({
                            identifiant: item.identifiant,
                            montant: parseFloat(item.montant),
                            qte: item.qte,
                            prix: item.prix
                        })
                        this.totalCarte += parseFloat(item.montant)
                        this.resetForm(formName)
                    }
                })
            },
             deleteRow(index, rows) {
                let item = rows.splice(index, 1);
                this.totalCarte -= parseInt(item[0].montant)
            },
             closeDialog(){
                this.$emit('close')
                this.logoDefaut = '/static/img-doc.png';
            },
            submitForm(formName)
            {
                if(this.typeDmd == "Autre" && this.formDmd.autre == undefined){
                    this.$message.error("Veuillez saisir ou selectionner le libelle");
                    return
                }
                else if(this.formDmd.caisseSelect == undefined){
                     this.$message.error("Veuillez selectionner une caisse");
                    return
                }
                else if(this.typeDmd == "Projet" && (this.formDmd.projet == undefined || this.formDmd.chantier == undefined  || this.formDmd.chantier == '')){
                // else if(this.typeDmd == "Projet" && (this.formDmd.projet == undefined)){
                    this.$message.error("Veuillez saisir ou selectionner le projet et le chantier");
                    return
                }
                this.$refs[formName].validate((valid) => {
                if (valid)
                {
                 this.loading = true
                 let form = document.getElementById("formDmd")
                 //recuperation des demandes
                 let data = new FormData(form);
                 let url = "";
                 if( this.editForm == false) //creer une nouvelle demande
                 {
                   url = this.domaine + 'demandeFond/create'
                 }
                 else  //modifier une demande de maintenance
                  {
                    url = this.domaine + 'demandeFond/edit'
                     data.append("idDmd", this.dmdDetail.id)
                 }
                 if(this.typeDmd == "Carburant")
                 {
                      data.append("montant",this.totalCarte)
                 }
                 else if(this.typeDmd == "Projet"){
                      data.append("montant",this.formDmd.montant)

                 }else if(this.typeDmd == "Mission")
                 {
                       data.append("montant",this.formDmd.montant)
                 }
                 data.append("idProjet",this.formDmd.projet)
                 data.append("idChantier",this.formDmd.chantier)
                 data.append("motif",this.formDmd.motif)
                 data.append("typeDmd",this.typeDmd)
                 data.append("idCaisse",this.formDmd.caisseSelect)
                 data.append("userId",this.user.id)
                 data.append("tableCarte",  JSON.stringify(this.tableCarte))
                 this.$http.post(url, data).then(response => {
                     //reinitialiser le formulaire
                  this.loading = false
                  this.tableCarte.splice(0);
                  this.resetForm('formDmd')
                  this.formDmd.motif = ''
                  this.successNotif(response.body.message)
                  this.closeDialog()
                  if(this.editForm){
                    window.location.reload();
                  }
                },
                (erreur) => {
                    //reinitialiser le formulaire
                    this.loading = false
                    this.resetForm('formDmd')
                    this.formDmd.motif = ''
                    this.closeDialog()
                    this.$message.error("Une erreur est survenue lors de l'enregistrement de la demande de fond")
                })
            }
            });
            },
           loadDemandeur(queryString, cb) {
      let url = this.domaine + "mission/listes-employe";
      var formdata = new FormData();
      formdata.append("user", this.user.id);
      formdata.append("tag", queryString);
      this.$http.post(url, formdata).then(
        response => {
          if (response.body) {
            var links = response.body;
            var results = queryString
              ? links.filter(this.createFilter(queryString))
              : links;
            cb(results);
          }
        },
        response => {}
      );
            },
        loadCaisse() {
            let url = this.domaine + "caisse/index";
            this.$http.get(url).then(response => {
              if (response.body) {
                this.listeCaisse = response.body.caisse;
              }
            });
          },

         loadZone(queryString, cb)
         {
            let url = this.domaine +  'demandeFond/listes-zone'
            var formdata = new FormData();
            formdata.append('user', this.user.id)
            formdata.append('tag', queryString)
            this.$http.post(url, formdata).then(response => {
                    if (response.body)
                    {
                        var links = response.body;
                        var results = queryString ? links.filter(this.createFilter(queryString)) : links;
                        cb(results);
                    }
                },
                response => {
                })
        },
        loadAutre(queryString, cb){
             let url = this.domaine +  'demandeFond/listes-autre'
            var formdata = new FormData();
            formdata.append('user', this.user.id)
            formdata.append('tag', queryString)
            this.$http.post(url, formdata).then(response => {
                    if (response.body)
                    {
                        var links = response.body;
                        var results = queryString ? links.filter(this.createFilter(queryString)) : links;
                        cb(results);
                    }
                },
            response => {
            })
        },

        createFilter(queryString) {
            return (link) => {
                return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },

      resetForm(formName) {
          this.formCarte.qte = 1;
          this.formCarte.prix = 1;
          this.formCarte.montant = 1;
          this.$refs[formName].resetFields();
          this.formDmd.montant = 5;
          this.logoDefaut = '/static/img-doc.png';
          this.closeDialog();
      },

      handleChangeCaisse(idCaisse){
          //this.caisseSelect = idCaisse
          this.formDmd.caisseSelect = idCaisse
      },
        successNotif(mess = ""){
            this.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: mess,
                type: 'success',
                position: 'top-center'
            })
        },

         selectProjet(idProjet)
         {
            // this.listeChantier.splice(0);
            this.formDmd.chantier = '';
            this.loadChantier(idProjet)
         },

          loadProjet () {
              let url = this.domaine + 'projet/index-projet-all'
              this.loading = true
              this.$http.get(url).then(response => {
                  this.loading = false
                      this.listeProjet = response.body.projet
              },errRep=>{
                   this.loading = false
                  this.$message.error("Une erreur est survenue lors du chargement de la liste des projets")
              })
          },

            loadChantier (item)
            {
              this.loading =  true
             //this.formDmd.chantier = '';
              let url = this.domaine + 'projet/'+ item +'/index/chantier'
              this.$http.get(url).then(response => {
                  this.loading = false
                  this.listeChantier = response.body.chantier
                  this.listeChantier.length > 0 ? (this.formDmd.chantier == this.listeChantier[0].id ): null
                  this.loadCaisseProjet(item);
              },errRep=>{
                   this.loading = false
                  this.$message.error("Une erreur est survenue lors du chargement de la liste du chntier")
              })
          },

           loadCaisseProjet (item) {
                if (item !== '') {
                     this.loading = true
                    let url = this.domaine + 'caisse/project/'+ item
                    this.$http.get(url).then(response => {
                        if (response.body)
                        {
                            this.loading = false;
                            this.formDmd.caisseSelect = response.body.caisse.id;
                            this.disabledSelectCaisse = true;
                        }
                    }, error=>{
                         this.loading = false
                    })
                } else {
                    this.disabledSelectCaisse = false;
                    this.loading = false
                }
            },
           loadCarte (){
            let url = this.domaine + 'carteCarburant/index'
            this.$http.get(url).then(response => {
                if (response.body) {
                    this.listeCarte = response.body.cartes
                }
            })
            },
      },
        mounted(){
            this.loadProjet();
            this.loadCaisse();
            this.loadCarte();
        }

    }
    </script>



// WEBPACK FOOTER //
// src/components/demandeFond/AjoutDemandeFond.vue